import { ImageValidation, InvalidImageError } from '../../types/FileUpload';

/**
 * Validate the size of an image
 * @param file - The file to validate
 * @param imageValidation - The validation rules for the image
 * @returns The error message if the image is invalid, otherwise null
 */
export const validateImageSize = async ({
  file,
  imageValidation,
}: {
  file: File;
  imageValidation?: ImageValidation;
}): Promise<InvalidImageError | null> => {
  if (!imageValidation) return null;

  const image = new Image();

  image.src = URL.createObjectURL(file);

  await image.decode();

  URL.revokeObjectURL(image.src);

  if (
    imageValidation.type === 'max' &&
    (image.width > imageValidation.width || image.height > imageValidation.height)
  ) {
    return { name: 'image-dimensions-too-large', maxWidth: imageValidation.width, maxHeight: imageValidation.height };
  } else if (
    imageValidation.type === 'min' &&
    (image.width < imageValidation.width || image.height < imageValidation.height)
  ) {
    return { name: 'image-dimensions-too-small', minWidth: imageValidation.width, minHeight: imageValidation.height };
  } else if (
    imageValidation.type === 'exact' &&
    (image.width !== imageValidation.width || image.height !== imageValidation.height)
  ) {
    return {
      name: 'image-dimensions-not-exact',
      requiredWidth: imageValidation.width,
      requiredHeight: imageValidation.height,
    };
  } else if (imageValidation.square && image.width !== image.height) {
    return { name: 'image-not-square' };
  }
  return null;
};
